module.exports = __webpack_public_path__ + "img/Wp_2031.c2c536da.png";